export function getIn(obj, path) {
    if(!obj || !Array.isArray(path) || path.length <= 0) {
        return null;
    }

    return path.reduce((pre,cur,idx,arr) => {
        if(typeof pre === 'undefined' || pre === null) {
            return pre;
        }

        return pre[arr[idx]];
    },obj);
}

/**
 * @param  {} cond 自定义检查函数
 * 构造自定义检查函数
 */
export const buildCheck = cond => (obj, path,...params) => {
    return cond(getIn(obj,path), ...params);
};

const isNotNullAndUndefined = val => !(val === void 0 || val === null);
const isStrEqual = (val, str) => val === str;

/**
 * @param  {} obj 需要检查的对象
 * @param  {} path 需要检查的某个属性的路径
 * @param  {} return ture/false, 当检查的属性是undefined 或者 null的时候 返回false 否则返回true
 * 检查某个对象的某个属性是否不等于undefined或者null
 */
export const isNotEmpty = buildCheck(isNotNullAndUndefined);
export const isEqualTo = buildCheck(isStrEqual);

export const inIframe = window.parent != window.self;



// WEBPACK FOOTER //
// ./src/components/util/check.js